import contains from "./contains";
import exclusiveMinimum from "./exclusiveMinimum";
import ipv6 from "./ipv6";
import maximum from "./maximum";
import minimum from "./minimum";
import required from "./required";
import dateTime from "./dateTime";
import hostname from "./hostname";
import maxItems from "./maxItems";
import minItems from "./minItems";
import multipleOf from "./multipleOf";
import tel from "./tel";
import email from "./email";
import maxLength from "./maxLength";
import minLength from "./minLength";
import number from "./number";
import uniqueItems from "./uniqueItems";
import exclusiveMaximum from "./exclusiveMaximum";
import ipv4 from "./ipv4";
import maxProperties from "./maxProperties";
import minProperties from "./minProperties";
import pattern from "./pattern";
import url from "./url";
import ajax from "./ajax";

export default {
  contains,
  exclusiveMinimum,
  ipv6,
  maximum,
  minimum,
  required,
  dateTime,
  hostname,
  maxItems,
  minItems,
  multipleOf,
  tel,
  email,
  maxLength,
  minLength,
  number,
  uniqueItems,
  exclusiveMaximum,
  ipv4,
  maxProperties,
  minProperties,
  pattern,
  url,
  ajax,
};
